import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';

import { isRouteActive } from '../../../utils/routeUtils';

import ButtonComponent from '../../button/ButtonComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

import './AccountNavComponent.scss';

class AccountNavComponent extends React.Component {
    getButtonColor = path => (isRouteActive(path, this.props.location) ? 'main' : 'fourth');

    render() {
        const { i18n } = this.props;

        return (
            <nav className="account-nav grid-4 has-gutter" id="account-nav">
                <LocalizedNavLink to={PATH.ACCOUNT_PROFILE_PATH} name="accountNav-toProfile">
                    <ButtonComponent
                        color={this.getButtonColor(PATH.ACCOUNT_PROFILE_PATH)}
                        text={i18n.PROFILE}
                    />
                </LocalizedNavLink>
                <LocalizedNavLink to={PATH.ACCOUNT_JACKPOT_PATH} name="accountNav-toMyJackpot">
                    <ButtonComponent
                        color={this.getButtonColor(PATH.ACCOUNT_JACKPOT_PATH)}
                        text={i18n.CASHBACK}
                    />
                </LocalizedNavLink>
                <LocalizedNavLink to={PATH.ACCOUNT_EBONS_PATH}>
                    <ButtonComponent
                        color={this.getButtonColor(PATH.ACCOUNT_EBONS_PATH)}
                        text={i18n.EBONS}
                    />
                </LocalizedNavLink>
                <LocalizedNavLink to={PATH.ACCOUNT_MESSAGES_PATH} name="accountNav-toMyMessages">
                    <ButtonComponent
                        color={this.getButtonColor(PATH.ACCOUNT_MESSAGES_PATH)}
                        text={i18n.MESSAGES}
                    />
                </LocalizedNavLink>
            </nav>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.NAV
    };
};

export default withRouter(connect(mapStateToProps)(AccountNavComponent));



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountNavComponent.js